import React from 'react';
import { useLanguage } from 'lib/i18n';

export function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();

  return (
    <label className="inline-flex h-9 w-[76px] shrink-0 items-center rounded-md border bg-background px-1.5">
      <span className="sr-only">{t('language.label')}</span>
      <select
        aria-label={t('language.label')}
        title={t('language.label')}
        value={language}
        onChange={(event) => setLanguage(event.target.value).catch(() => {})}
        className="w-full cursor-pointer appearance-none bg-transparent text-center text-xs font-semibold outline-none"
      >
        <option value="fr">🇫🇷 FR</option>
        <option value="en">🇬🇧 EN</option>
      </select>
    </label>
  );
}
